/**
 * QuickActionsPanel — vertical button stack for the most common member-side
 * project actions. Plain themed buttons; no metrics or animations.
 */

import { useNavigate } from 'react-router-dom';
import { Button, Card, Group, Stack, ThemeIcon, Title } from '@/components/ui';
import {
  IconBolt,
  IconPlus,
  IconUser,
  IconLayoutKanban,
  IconCalendarTime,
  IconReportAnalytics,
} from '@tabler/icons-react';
import { PROJECTS_ROUTES, TASKS_ROUTES } from '@/config/routes';

interface Action {
  label: string;
  icon: React.ReactNode;
  to: string;
}

const ACTIONS: Action[] = [
  { label: 'New Project', icon: <IconPlus size={16} />, to: PROJECTS_ROUTES.CREATE },
  { label: 'My Projects', icon: <IconUser size={16} />, to: PROJECTS_ROUTES.MY_PROJECTS },
  { label: 'Task Board', icon: <IconLayoutKanban size={16} />, to: TASKS_ROUTES.BOARD },
  { label: 'Calendar', icon: <IconCalendarTime size={16} />, to: PROJECTS_ROUTES.CALENDAR },
  { label: 'Reports', icon: <IconReportAnalytics size={16} />, to: PROJECTS_ROUTES.REPORTS },
];

export function QuickActionsPanel() {
  const navigate = useNavigate();
  return (
    <Card withBorder padding="lg" radius="md">
      <Group gap="xs" mb="sm">
        <ThemeIcon size="md" variant="light" color="indigo" radius="xl">
          <IconBolt size={16} />
        </ThemeIcon>
        <Title order={5}>Quick Actions</Title>
      </Group>
      <Stack gap="xs">
        {ACTIONS.map((a) => (
          <Button
            key={a.to}
            variant="default"
            justify="space-between"
            leftSection={a.icon}
            fullWidth
            onClick={() => navigate(a.to)}
          >
            {a.label}
          </Button>
        ))}
      </Stack>
    </Card>
  );
}
